import simpleParallax from 'simple-parallax-js';

export default class myParallax {

    image_outside() {
        var outside = document.querySelectorAll('.image-parallax-outside');
        new simpleParallax(outside, {
            overflow: true,
            //delay: .6,
            orientation: 'down',
            transition: 'cubic-bezier(0,0,0,1)',
            //customWrapper: '.th-about-slider'
        });
    }


    image_inside() {
 
        var inside = document.querySelectorAll('.image-parallax-inside');
        new simpleParallax(inside, {
            overflow: false,
            //delay: .6,
            orientation: 'down',
            transition: 'cubic-bezier(0,0,0,1)',
            //customWrapper: '.th-about-slider'
        });
    }
  
    init() {
        if (window.innerWidth > 992) {
            document.querySelector('.image-parallax-outside') ? this.image_outside() : null;
            document.querySelector('.image-parallax-inside') ? this.image_inside() : null;
        }
    }
}